import { render, staticRenderFns } from "./SliceHeader.vue?vue&type=template&id=1436c878&scoped=true&"
import script from "./SliceHeader.vue?vue&type=script&lang=js&"
export * from "./SliceHeader.vue?vue&type=script&lang=js&"
import style0 from "./SliceHeader.vue?vue&type=style&index=0&id=1436c878&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1436c878",
  null
  
)

export default component.exports